export default "__VITE_ASSET__Ebb5_y$o__";